/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Description_Length_HelpInputs */

const en_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shorter scene descriptions are easier to scan when reviewing your project.`)
};

const fr_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des descriptions de scènes plus courtes sont plus faciles à parcourir lors de la révision de votre projet.`)
};

const de_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kürzere Szenenbeschreibungen lassen sich beim Durchsehen Ihres Projekts leichter überfliegen.`)
};

const it_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizioni delle scene più brevi sono più facili da consultare durante la revisione del progetto.`)
};

const ru_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кратковременные описания сцен легче просматривать при оценке проекта.`)
};

const es_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las descripciones de escenas más breves son más fáciles de leer al revisar tu proyecto.`)
};

const zh_cn2_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较短的场景描述在审阅项目时更容易浏览。`)
};

const ja_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーンの説明が短い方が、プロジェクトを確認する際にざっと目を通しやすい。`)
};

const hi_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने प्रोजेक्ट की समीक्षा करते समय छोटे दृश्य विवरणों को पढ़ना आसान होता है।`)
};

const pt_pt2_sd_description_length_help = /** @type {(inputs: Sd_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrições de cena mais curtas são mais fáceis de analisar durante a revisão do seu projeto.`)
};

/**
* | output |
* | --- |
* | "Shorter scene descriptions are easier to scan when reviewing your project." |
*
* @param {Sd_Description_Length_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_description_length_help = /** @type {((inputs?: Sd_Description_Length_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Description_Length_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sd_description_length_help(inputs)
	if (locale === "de") return de_sd_description_length_help(inputs)
	if (locale === "it") return it_sd_description_length_help(inputs)
	if (locale === "ru") return ru_sd_description_length_help(inputs)
	if (locale === "es") return es_sd_description_length_help(inputs)
	if (locale === "zh-CN") return zh_cn2_sd_description_length_help(inputs)
	if (locale === "ja") return ja_sd_description_length_help(inputs)
	if (locale === "hi") return hi_sd_description_length_help(inputs)
	if (locale === "pt-PT") return pt_pt2_sd_description_length_help(inputs)
	return en_sd_description_length_help(inputs)
});